import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthPage from "@/pages/AuthPage";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Habits from "@/pages/Habits";
import CalendarPage from "@/pages/CalendarPage";
import Planner from "@/pages/Planner";
import Budget from "@/pages/Budget";
import Health from "@/pages/Health";
import ChatPage from "@/pages/ChatPage";
import MapPage from "@/pages/MapPage";
import AssistantPage from "@/pages/AssistantPage";
import SharePage from "@/pages/SharePage";
import TwinPage from "@/pages/TwinPage";
import NutritionPage from "@/pages/NutritionPage";
import WrappedPage from "@/pages/WrappedPage";
import FamilyWrappedPage from "@/pages/FamilyWrappedPage";
import LabsPage from "@/pages/LabsPage";
import OsintPage from "@/pages/OsintPage";
import AIPage from "@/pages/AIPage";
import GlassPage from "@/pages/GlassPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="loading-screen">
        <div className="text-muted-foreground text-sm">Загрузка…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<AuthPage />} />
          <Route path="/s/:token" element={<SharePage />} />
          <Route path="/glass" element={<GlassPage />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="habits" element={<Habits />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="planner" element={<Planner />} />
            <Route path="budget" element={<Budget />} />
            <Route path="health" element={<Health />} />
            <Route path="chat" element={<ChatPage />} />
            <Route path="map" element={<MapPage />} />
            <Route path="assistant" element={<AssistantPage />} />
            <Route path="twin" element={<TwinPage />} />
            <Route path="nutrition" element={<NutritionPage />} />
            <Route path="wrapped" element={<WrappedPage />} />
            <Route path="family-wrapped" element={<FamilyWrappedPage />} />
            <Route path="labs" element={<LabsPage />} />
            <Route path="osint" element={<OsintPage />} />
            <Route path="ai" element={<AIPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
